import React from 'react';
import { FileTextIcon, HandshakeIcon, ClipboardCheckIcon, DollarSignIcon } from 'lucide-react';
import { PageHero } from '../components/ui/PageHero';
import { Reveal } from '../components/fx/Reveal';
import { SectionHeading } from '../components/ui/SectionHeading';
import { ContactSection } from '../components/sections/ContactSection';
const steps = [{
  icon: ClipboardCheckIcon,
  title: 'Document Damage',
  text: 'We thoroughly photograph and itemize all damage for your claim.'
}, {
  icon: FileTextIcon,
  title: 'File the Claim',
  text: 'We prepare and submit the paperwork directly with your carrier.'
}, {
  icon: HandshakeIcon,
  title: 'Advocate For You',
  text: 'We communicate with adjusters to ensure a fair, complete claim.'
}, {
  icon: DollarSignIcon,
  title: 'Maximize Coverage',
  text: "We work to recover every dollar you're entitled to for your home."
}];
export function Insurance() {
  return <>
      <PageHero eyebrow="Insurance Claims" title="We Handle the Claim. You Focus on Home." subtitle="Navigating insurance after damage is stressful. Dream Shield manages the entire process on your behalf — start to finish." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Insurance Claims'
    }]} data-id="element-480" data-mp="229yjl4ms2oy4" />
      <section className="mx-auto max-w-7xl px-6 py-16" data-id="element-481" data-mp="1jbmcrpjc9r5p">
        <SectionHeading eyebrow="How It Works" title="Stress-Free Claim Management" data-id="element-482" data-mp="1jd76jcxtx62i" />
        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-483" data-mp="1sbsk0tog1uwf">
          {steps.map((s, i) => <Reveal key={s.title} delay={i * 0.1} data-id="element-484" data-mp="1xb55pb3kwvxf" data-mpi={i}>
              <div className="gradient-border h-full rounded-4xl p-8 shadow-glass" data-id="element-485" data-mp="1xbx22o502xor">
                <span className="font-display text-sm font-bold text-electric" data-id="element-486" data-mp="33pwf636rpp32">
                  STEP {i + 1}
                </span>
                <div className="mt-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-success/10 text-success" data-id="element-487" data-mp="38rlrdm5q88sq">
                  <s.icon className="h-7 w-7" strokeWidth={1.8} data-id="element-488" data-mp="14m7n2j8v7aw8" />
                </div>
                <h3 className="mt-5 font-display text-lg font-bold text-navy" data-id="element-489" data-mp="1ilp58frnnpwm">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-slate" data-id="element-490" data-mp="1dmcn28bqb70d">
                  {s.text}
                </p>
              </div>
            </Reveal>)}
        </div>
      </section>
      <ContactSection data-id="element-491" data-mp="kyq700lbe9wm" />
    </>;
}